let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("irKcy")).then(() => parcelRequire('gOk31'));